import { Download } from "lucide-react";
import { useEffect } from "react";
import { Button } from "@/shared/components/ui/button";
import { useDownloadPdf } from "@/shared/lib/utilities/download-pdf";
import { useToast } from "@/shared/hooks/use-toast";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import {
  useVbsWorkOrderDownloadPDFMutation,
  WorkOrderDocument,
} from "@/services/backend/vbs/work-orders/api/work-order-api";

export function DownloadButton({
  workOrderId,
  document: documentType,
  text,
}: {
  workOrderId: string;
  document: WorkOrderDocument;
  text: string;
}) {
  const [download, { isLoading, error, data, reset }] =
    useVbsWorkOrderDownloadPDFMutation();
  const { toast } = useToast();

  useDownloadPdf(data, reset);

  useEffect(() => {
    if (error) {
      toast({
        ...parseRTKQueryError(error),
        variant: "destructive",
      });
    }
  }, [toast, error]);

  const doDownload = () => {
    if (isLoading) {
      return;
    }

    download({
      id: workOrderId,
      document: documentType,
    });
  };

  return (
    <Button variant="outline" className="justify-start" onClick={doDownload}>
      {isLoading ? (
        <Download className="mr-4 h-5 w-5 animate-bounce" />
      ) : (
        <Download className="mr-4 h-5 w-5" />
      )}
      <span>{text}</span>
    </Button>
  );
}
